import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from './pages.component';
import { AuthGuard } from '../shared';

//TODO: add auth guard
const routes: Routes = [
    {
        path: '',
        component: PagesComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('../login/login.module').then(m => m.LoginModule)
            },
            {
                path: 'registration-complete',
                loadChildren: () => import('./registration-complete/registration-complete.module').then(m => m.RegistrationCompleteModule)
            },
            {
                path: 'product-select',
                loadChildren: () => import('./product-select/product-select.module').then(m => m.ProductSelectModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'plans-nbca',
                loadChildren: () => import('./plans-nbca/plans-nbca.module').then(m => m.PlansNBCAModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'plans-nbca/:subid',
                loadChildren: () => import('./plans-nbca/plans-nbca.module').then(m => m.PlansNBCAModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'plans-new',
                loadChildren: () => import('./plans-new/plans-new.module').then(m => m.PlansNewModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'plans-new/:subid',
                loadChildren: () => import('./plans-new/plans-new.module').then(m => m.PlansNewModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'profile',
                loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'admin',
                loadChildren: () => import('./admin-page/admin-page.module').then(m => m.AdminPageModule),
                canActivate: [AuthGuard],
                data: {
                }
            },
            {
                path: 'error/:type',
                loadChildren: () => import('./error-page/error-page.module').then(m => m.ErrorPageModule)
            },
            {
                path: 'logout',
                loadChildren: () => import('./empty-page/empty-page.module').then(m => m.EmptyPageModule)
            },
            {
                path: 'reseller',
                loadChildren: () => import('./reseller/reseller.module').then(m => m.ResellerModule)
            }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
